import {Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {SectionWrapper} from './SectionWrapper';

export const IngredientsSection: FC<{
  label: string;
  attributes: string;
}> = ({label, attributes}) => {
  return (
    <SectionWrapper dataTestId={`productDetailsIngredientsSection_${label}`}>
      <Ingredients>
        <Text size="px14">{attributes}</Text>
      </Ingredients>
    </SectionWrapper>
  );
};

const Ingredients = styled.dd`
  margin: 1.25rem 0 0 0;
`;
